import type { Event } from '@patsnap/tahiti-core/common/event';

export const UserPreRedirectLoginService = Symbol.for('UserPreRedirectLoginService');

export interface UserPreRedirectLoginService {
    updateKickedOut: ()=> void;
    isKickedOut: boolean;
    onStatesChange: Event<boolean>;
}
